import React, { FC } from 'react';

import { IMerchant } from 'src/prize/types/shoppe';

import { Logo } from './atoms/Logo';
import { Links } from './molecules/Links';

import styles from './index.module.sass';

interface IFooterProps {
  merchant: IMerchant;
}

export const Footer: FC<IFooterProps> = ({ merchant: { prizeFilePath, privacyPolicyUrl }}) => (
  <footer className={`${styles.container} footer--prize`}>
    <Logo />

    <Links prizeFilePath={prizeFilePath} privacyPolicyUrl={privacyPolicyUrl} />
  </footer>
);
